import OtherCourses from './OtherCourses';

export default OtherCourses;
